import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../auth/auth.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  routesAllowed: string[];
  constructor(private authService: AuthService) {
    this.routesAllowed = [];
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    this.routesAllowed = JSON.parse(sessionStorage.getItem('routes'));
    this.routesAllowed.length > 0 ? this.routesAllowed.push('dashboard') : null;
    let routeInitName = route.routeConfig.path.split('/')[0];

    if (this.routesAllowed?.includes(routeInitName)) {
      return true;
    } else {
      return false;
    }
  }
}
